import { useTranslation } from 'react-i18next'

import { useOptionalSeller } from '~/hooks/data/use-seller'
import { TextEditable } from '~/ui'
import { cn } from '~/utils/classnames'

import { useCollectionConfiguration } from './collection-configuration-context'
import { registerCollectionField } from './utils'

type FieldId = 'name' | 'description'

export const CollectionDetails = () => {
  const seller = useOptionalSeller()
  const { t } = useTranslation()
  const { collection, liveErrors, dispatch } = useCollectionConfiguration()

  if (!seller) {
    return (
      <div className="mx-auto max-w-[374px]">
        {collection.name ? (
          <h2
            className={cn(
              'text-foreground px-2 text-center text-xl font-medium'
            )}
          >
            {collection.name}
          </h2>
        ) : null}{' '}
        {collection.description ? (
          <p className={cn('text-md text-foreground mt-2 px-2 text-center')}>
            {collection.description}
          </p>
        ) : null}
      </div>
    )
  }

  const handleChange = (fieldId: FieldId) => {
    return (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      dispatch({
        type: 'patch',
        payload: { [fieldId]: event.target.value },
      })
    }
  }

  return (
    <div className="mx-auto w-full max-w-[374px]">
      <div className="flex flex-col items-center px-2 @lg:px-0">
        <TextEditable className="mb-2">
          <TextEditable.Textarea
            {...registerCollectionField(collection, 'name', liveErrors)}
            placeholder={
              t('input.create_collection.collection_name_placeholder')!
            }
            preventLineBreaks
            value={collection.name || ''}
            onChange={handleChange('name')}
            className="w-min-0 text-foreground mx-auto w-fit text-center text-lg font-medium md:text-xl"
            maxLength={50}
          />
        </TextEditable>

        <TextEditable className="text-foreground/64 w-full text-lg">
          <TextEditable.Textarea
            {...registerCollectionField(collection, 'description', liveErrors)}
            placeholder={
              t('input.create_collection.collection_description_placeholder')!
            }
            value={collection.description || ''}
            onChange={handleChange('description')}
            className="w-min-0 mx-auto text-center text-sm whitespace-pre-wrap"
            maxLength={120} // backend can take up to 500 characters though
          />
        </TextEditable>
      </div>
    </div>
  )
}
